<app-main-header [name_main]="'Usuarios'">
    <button class="btn-upload" mat-stroked-button color="primary" (click)="openImportModal()">
        Upload
    </button>
    <button class="check-btn" mat-flat-button routerLink="/users/create">
        CREAR
    </button>
    <button [disabled]="!selectedProducts.length" class="check-btn" mat-flat-button color="warn"
    (click)="deleteUser(selectedProducts)">
    BORRAR
</button>
</app-main-header>
<app-data-table 
    [data]="formattedUsersData" 
    [columns]="columns" 
    [rows]="10" 
    [rowsPerPageOptions]="[10, 25, 50]" 
    (rowSelect)="onRowSelect($event)" 
    [selection]="selectedItems" 
    (selectionChange)="onSelectionChange($event)"
    [sortField]="'users'"
    [sortOrder]="-1"
    [showFilters]="true"
    (deleteItems)="onDeleteItems($event)"
    (editItem)="onEditItem($event)">
</app-data-table> 

